import { cloneDeep } from "lodash";

const preBuiltFields = new Map();

const setFieldProp = (field, rule, item) => {
  const { template_field_name, field_property_key, data_item_key } = rule;
  if (field.name === template_field_name) {
    field[field_property_key] = item[data_item_key];
  }
};

const setTagForCurrent = (state, tagPrefix, index) => {
  state.tags = `${tagPrefix}_${index}`;
};

const setTagForAll = (state, tagPrefix, _, itemsNumber) => {
  const itemNumbers = [...Array(itemsNumber).keys()];
  state.tags = "";
  itemNumbers.forEach(number => (state.tags += `${tagPrefix}_${number}|`));
};

const setTagForOther = (state, tagPrefix, index, itemsNumber) => {
  const itemNumbers = [...Array(itemsNumber).keys()];
  state.tags = "";
  itemNumbers.forEach(number => {
    if (number !== index) {
      state.tags += `${tagPrefix}_${number}|`;
    }
  });
};

const setTagsMap = {
  $current_tag: setTagForCurrent,
  $all_tags: setTagForAll,
  $other_tags: setTagForOther
};

const setFieldTag = (field, index) => {
  const tag = field?.data?.actionEventStatesTags;
  if (tag) {
    const [generalTag = "", tagFormat] = tag.split("|");

    if (tagFormat && tagFormat.startsWith("$")) {
      const [, tagPrefix] = tag.split(":");
      field.data.actionEventStatesTags = `${generalTag}|${tagPrefix}_${index}`;
    }
  }
};

const setEventStatesTags = (field, index, itemsNumber) => {
  const states = field?.data?.actionEventStates?.[0]?.states;

  if (states?.length) {
    states.forEach(state => {
      const { tags } = state;
      if (tags) {
        if (tags.startsWith("$")) {
          const [tagFormat, tagPrefix] = tags.split(":");
          if (typeof setTagsMap[tagFormat] === "function") {
            setTagsMap[tagFormat](state, tagPrefix, index, itemsNumber);
          }
        }
        const [generalTag = "", tagFormat] = tags.split("|");
        if (tagFormat && tagFormat.startsWith("$")) {
          const [, tagPrefix] = tags.split(":");
          state.tags = `${generalTag}|${tagPrefix}_${index}`;
        }
      }
    });
  }
};

const buildFieldByTemplate = (
  templateField,
  convertRules,
  itemsList,
  saveRawData,
  mapKey = null
) => {
  let currentFields = mapKey ? preBuiltFields.get(mapKey) : null;
  if (!currentFields && itemsList?.length) {
    currentFields = itemsList.map((item, index) => {
      const field = cloneDeep(templateField);
      if (saveRawData) {
        field.text = item;
      }
      field.name += index;
      setFieldTag(field, index);
      setEventStatesTags(field, index, itemsList.length);
      convertRules.forEach(rule => {
        setFieldProp(field, rule, item);

        if (field.type === "container") {
          const containerFields =
            field?.fieldLayouts?.[0]?.containerFields || [];
          containerFields.forEach(containerField => {
            setFieldProp(containerField, rule, item);
            setFieldTag(containerField, index);
          });
        }
      });
      return field;
    });

    if (mapKey) {
      preBuiltFields.set(mapKey, currentFields);
    }
  }
  return currentFields;
};

export const clearPreBuiltFields = () => {
  preBuiltFields.clear();
};

export default buildFieldByTemplate;
